export default "__VITE_ASSET__d2df2c9a__"